export default {
      id: "as-off-site-parking-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-off-site-parking",
      toString: function () {
        return this.url;
      }
    }